import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import ProfileStyle from "../../assets/stylesheets/dashboard/profile.module.css";
import SideBar from "./SideBar";
import useAuthStore from "../../store/authStore";

export default function DashboardLayout({ children, userName, userSubtitle }) {
  const { user } = useAuth0();
  const { userProfile } = useAuthStore();

  const profileFullName = [userProfile?.firstName, userProfile?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  // Prefer DB profile name. Avoid Auth0 `user.name` as it is often an email.
  const auth0FallbackName = [user?.given_name, user?.family_name]
    .filter(Boolean)
    .join(" ")
    .trim();

  const resolvedUserName =
    userName ||
    profileFullName ||
    auth0FallbackName ||
    user?.nickname ||
    "Farmciti";

  const resolvedUserSubtitle =
    userSubtitle || userProfile?.email || user?.email;

  return (
    <div className={ProfileStyle["container"]}>
      <div className={ProfileStyle["content-wrapper"]}>
        <SideBar userName={resolvedUserName} userSubtitle={resolvedUserSubtitle} />

        <div className={ProfileStyle["main-content"]}>{children}</div>
      </div>
    </div>
  );
}
